import { app } from '../../../../app';
import { appProtocolDisplayName } from '../../../../../util/sp-util';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.software-license-management.add', {
        url: '/add/:appId',
        params: {appId: null},
        component: 'companySoftwareLicenseManagementAdd',
        resolve: {
            applications,
            selectedApp
        },
    });
}

/** @ngInject */
function applications(companyId, SoftwareLicenseManagementService) {
    return SoftwareLicenseManagementService.getAssignableApplications(companyId)
    .then(applications => applications.map(app => ({...app, protocol: appProtocolDisplayName(app)})));
}

/** @ngInject */
function selectedApp(applications, $stateParams) {
    return applications.find(app => app.id === $stateParams.appId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/software-license-management/add/software-license-management-add.state.js